import { primaryImageStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.primaryImage = {
    ...styles.primaryImage,
    centeringWrapper: {
        ...styles.primaryImage?.centeringWrapper,
        css: css`
            ${styles.primaryImage?.centeringWrapper?.css}
            border: solid 1px ${getColor(colorStrings.commonBorder)};
            border-radius: 4px;
            padding: 16px;
        `,
    },
};
